import { render, staticRenderFns } from "./ValidateForSignProModal.vue?vue&type=template&id=b65431ba&"
import script from "./ValidateForSignProModal.vue?vue&type=script&lang=js&"
export * from "./ValidateForSignProModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports